// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"7198":"fe66ba4c646dad2b","8386":"d283b895985ff5b7","8424":"f2da2b5a0883b518"}[chunkId] + ".css";
};